// extracted by mini-css-extract-plugin
module.exports = {"root":"ChangeLogSidebar_root__3MvB7","paper":"ChangeLogSidebar_paper__3RR4F","loading":"ChangeLogSidebar_loading__3opxH"};